<section *ngIf="voucher" class="container py-5 mt-5 mb-sm-2 mb-lg-3 mb-xl-4 mb-xxl-5">
  <h2 class="h1">{{voucher.name}}</h2>
  <div class="row pb-sm-1 pb-md-4">
    <div class="col-lg-8 mb-3 mb-md-0">
      <!-- Card details -->
      <section class="card bg-secondary border-0 mb-4 mb-lg-0">
        <div class="card-body">
          <!-- <ng-scrollbar class="overflow-y-auto h-96 rounded-3 border border-1"> -->
          <p [innerHTML]="voucherDescription | safe: 'html'" class="card-text"></p>
          <!-- </ng-scrollbar> -->
        </div>
      </section>
    </div>

    <div class="col-lg-4">
      <div class="d-none d-md-block" style="margin-top: -90px;"></div>
      <div class="position-md-sticky top-0">
        <div class="d-none d-md-block" style="padding-top: 90px;"></div>

        <aside class="card bg-secondary border-0 mb-4">
          <img [src]="voucherImageUrl" [alt]="voucher.name" class="card-img p-2">
          <div class="card-body">

            <form *ngIf="userId" [formGroup]="form" (ngSubmit)="onSubmit()" class="pt-0" novalidate autocomplete="off">

              <ng-container *ngIf="voucher.fixedRange">
                <div class="h6">Valori</div>
                <div class="d-flex flex-wrap align-content-between">
                  <div *ngFor="let x of rangeGiftValues; index as i" class="me-3 mb-2">
                    <input formControlName="amount" [id]="i" [value]="x" class="btn-check" type="radio">
                    <label class="btn btn-outline-secondary px-2" [for]="i"><span class="mx-1">{{x}}</span></label>
                  </div>
                  <div *ngIf="vs.hasErrors(form, 'amount')" class="invalid-feedback">{{vs.getError(form,
                    'amount')}}</div>
                </div>
              </ng-container>

              <ng-container *ngIf="!voucher.fixedRange">
                <div class="h6">Valoare</div>
                <div class="mb-0">
                  <div class="input-group">
                    <input formControlName="amount" [ngClass]="{'is-invalid': vs.hasErrors(form, 'amount')}"
                      inputmode="numeric" step="1" pattern="[0-9]*" gsDecimalInput [decimal]="false" [min]="1"
                      [max]="99999" class="form-control form-control-lg" type="number">
                    <span class="input-group-text">.00 LEI</span>
                  </div>
                  <div *ngIf="vs.hasErrors(form, 'amount')" class="invalid-feedback">{{vs.getError(form,
                    'amount')}}</div>
                </div>
              </ng-container>

              <ng-container *ngFor="let optionType of voucher.optionTypes">
                <div class="h6 pt-3">{{optionType.name}}</div>
                <div class="mb-0">
                  <select [formControlName]="optionType.name"
                    [ngClass]="{'is-invalid': vs.hasErrors(form, optionType.name)}" class="form-select">
                    <option [ngValue]="null">Selecteaza {{optionType.name}}</option>
                    <option *ngFor="let option of optionType.options" [ngValue]="option.id">
                      {{option.name}}
                    </option>
                  </select>
                  <div *ngIf="vs.hasErrors(form, optionType.name)" class="invalid-feedback">{{vs.getError(form,
                    optionType.name)}}
                  </div>
                </div>
              </ng-container>

              <!-- Action buttons-->
              <div class="d-sm-flex d-lg-block d-xxl-flex py-4 py-md-5 my-3 my-md-0 mt-lg-0 mb-lg-4">
                <div class="d-flex flex-column position-relative align-items-start">
                  <div class="count-input bg-gray rounded-3 me-4 mb-3 mb-sm-0 mb-lg-3 mb-xxl-0">
                    <button (click)="changeQuantityClick(form.value.quantity - 1)" class="btn btn-icon btn-lg fs-xl"
                      type="button">-</button>
                    <input formControlName="quantity" [ngClass]="{'is-invalid': vs.hasErrors(form, 'quantity')}"
                      class="form-control" type="number">
                    <button (click)="changeQuantityClick(form.value.quantity + 1)" class="btn btn-icon btn-lg fs-xl"
                      type="button">+</button>
                  </div>
                  <div *ngIf="vs.hasErrors(form, 'quantity')" class="invalid-feedback">{{vs.getError(form,
                    'quantity')}}</div>
                </div>

                <button class="btn btn-lg btn-primary w-100 w-lg-auto me-2" type="submit"><i
                    class="ai-cart me-2 ms-n1"></i>Adauga in cos</button>
              </div>
            </form>

            <div *ngIf="!userId">
              <p class="h5">Nu esti autentificat. Pentru a plasa o comanda, te rugam sa te autentifici.</p>
              <a class="btn btn-lg btn-primary w-100 mt-2" [routerLink]="['/auth/autentificare']"><i
                  class="ai-login me-2"></i>Autentificare
              </a>
            </div>

            <!-- Sharing-->
            <div class="mt-4">
              <h4 class="h6 me-4">Distribuie:</h4>
              <gs-social-share [url]="giftCardUrl"></gs-social-share>
            </div>
          </div>
        </aside>
      </div>
    </div>
  </div>
</section>

<!-- Loading template -->
<section *ngIf="!voucher" class="container py-5 mt-5 mb-sm-2 mb-lg-3 mb-xl-4 mb-xxl-5">
  <h2 class="h1 placeholder-glow"><span class="placeholder col-6"></span></h2>
  <div class="row pb-sm-1 pb-md-4">
    <div class="col-lg-8 mb-3 mb-md-0">
      <!-- Card details -->
      <section class="card bg-secondary border-0 mb-4 mb-lg-0">
        <div class="card-body">
          <div class="position-relative placeholder-glow">
            <div class="card-img p-2 placeholder ratio ratio-21x9"></div>
            <i class="ai-image position-absolute top-50 start-50 translate-middle fs-1 opacity-50"></i>
          </div>

          <p class="card-text placeholder-glow mt-4">
            <span class="placeholder placeholder-sm col-7 me-2"></span>
            <span class="placeholder placeholder-sm col-4"></span>
            <span class="placeholder placeholder-sm col-4 me-2"></span>
            <span class="placeholder placeholder-sm col-6"></span>
            <span class="placeholder placeholder-sm col-12"></span>
            <span class="placeholder placeholder-sm col-7 me-2"></span>
            <span class="placeholder placeholder-sm col-4"></span>
            <span class="placeholder placeholder-sm col-4 me-2"></span>
            <span class="placeholder placeholder-sm col-6"></span>
            <span class="placeholder placeholder-sm col-12"></span>
            <span class="placeholder placeholder-sm col-7 me-2"></span>
            <span class="placeholder placeholder-sm col-4"></span>
            <span class="placeholder placeholder-sm col-4 me-2"></span>
            <span class="placeholder placeholder-sm col-6"></span>
            <span class="placeholder placeholder-sm col-12"></span>
            <span class="placeholder placeholder-sm col-7 me-2"></span>
            <span class="placeholder placeholder-sm col-4"></span>
            <span class="placeholder placeholder-sm col-4 me-2"></span>
            <span class="placeholder placeholder-sm col-6"></span>
            <span class="placeholder placeholder-sm col-12"></span>
          </p>
        </div>
      </section>
    </div>

    <div class="col-lg-4">
      <div class="d-none d-md-block" style="margin-top: -90px;"></div>
      <div class="position-md-sticky top-0">
        <div class="d-none d-md-block" style="padding-top: 90px;"></div>

        <aside class="card bg-secondary border-0 mb-4">
          <div class="position-relative placeholder-glow">
            <div class="card-img p-2 placeholder ratio ratio-16x9"></div>
            <i class="ai-image position-absolute top-50 start-50 translate-middle fs-1 opacity-50"></i>
          </div>

          <div class="card-body">
            <div class="h6">Valori</div>
            <div class="d-flex flex-wrap align-content-between placeholder-glow">
              <span *ngFor="let item of [].constructor(5); index as i"
                class="placeholder placeholder-lg col-2 me-3 mb-2"></span>
            </div>

            <!-- Action buttons-->
            <div class="d-sm-flex d-lg-block d-xxl-flex py-4 py-md-5 my-3 my-md-0 mt-lg-0 mb-lg-4">
              <span class="placeholder placeholder-lg col-4 me-4 mb-3 mb-sm-0 mb-lg-3 mb-xxl-0"></span>
              <a href="#" tabindex="-1"
                class="btn btn-lg btn-primary disabled placeholder placeholder-glow w-100 w-lg-auto me-2 "><i
                  class="ai-cart me-2 ms-n1"></i>Adauga in cos</a>
            </div>

            <!-- Sharing-->
            <div class="mt-4">
              <h4 class="h6 me-4">Distribuie:</h4>
              <div class="placeholder-glow">
                <span *ngFor="let item of [].constructor(5)"
                  class="placeholder col-1 me-3 mb-3"></span>
              </div>
            </div>
          </div>
        </aside>
      </div>
    </div>
  </div>
</section>
